import React, { useState, useEffect } from 'react';
import Page from 'src/components/Page';
import services from '../Services';
import PageHeader from 'src/views/Common/PageHeader';
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import MaterialTable from "material-table";
import { useAlert } from "react-alert";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Box, Card, makeStyles, Container, CardHeader, Button, CardContent, Divider, MenuItem, Grid, InputLabel, Checkbox, TextField, Chip, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, IconButton, TablePagination } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    }
}));

const screenCode = 'QUOTATION';
export default function QuotationListing() {
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const classes = useStyles();
    const alert = useAlert();
    const [isCleared, setIsCleared] = useState(false);
    const [groups, setGroups] = useState([]);
    const [title, setTitle] = useState("Quotation Listing");
    const [factories, setFactories] = useState([]);
    const [status, setStatus] = useState([]);
    const [requisitions, setRequisitions] = useState([]);
    const [isShowTable, setIsShowTable] = useState(false);
    const navigate = useNavigate();
    const [QuotationNumber, setQuotationNumber] = useState('');
    const [pagination, setPagination] = useState({});
    const [QuotationDetailsData, setQuotationDetailsData] = useState([]);
    const handleClick = () => {
        navigate('/app/Quatation/addEidt')
    };
    const [quotationDetails, setQuotationDetails] = useState({
        groupID: 0,
        factoryID: 0,
        requisitionID: 0,
        skuMasterID: 0,
        itemCategoryID: 0,
        itemID: 0,
        supplierID: 0,
        appliedType: 0,
        statusID: 0
    });

    async function getPermissions() {
        const permissions = await authService.getPermissionsByScreen(screenCode);
        const isAuthorized = permissions.find(p => p.permissionCode === 'VIEWQUOTATION');
        if (!isAuthorized) {
            navigate('/404');
        }
        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: !!permissions.find(p => p.permissionCode === 'GROUPDROPDOWN'),
            isFactoryFilterEnabled: !!permissions.find(p => p.permissionCode === 'FACTORYDROPDOWN')
        });

        setQuotationDetails({
            ...quotationDetails,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken())
        });

    }
    async function getGroupsForDropdown() {
        const groups = await services.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getStatus() {
        const status = await services.getStatus();
        setStatus(status);
    }

    async function getFactoriesForDropdown() {
        const factories = await services.getAllFactoriesByGroupID(quotationDetails.groupID);
        setFactories(factories);
    }

    async function getRequisitionsForDropdown() {
        const requisitions = await services.getAllRequisionsByFactoryID(quotationDetails.factoryID);
        setRequisitions(requisitions);
    }

    function handleSearchDropdownChange(data, e) {
        if (data === undefined || data === null) {
            setQuotationDetails({
                ...quotationDetails,
                requisitionID: 0,
                skuMasterID: 0
            });
            setIsCleared(!isCleared)
            return;
        } else {
            var valueV = data["requisitionID"];
            setQuotationDetails({
                ...quotationDetails,
                requisitionID: valueV.toString(),
                skuMasterID: 0
            });
            setQuotationDetailsData([]);
            setIsCleared(!isCleared)
        }
    }

    useEffect(() => {
        setQuotationDetails({
            ...quotationDetails,
            requisitionID: 0,
            skuMasterID: 0
        });
        setQuotationDetailsData([])
        trackPromise(getRequisitionsForDropdown());
    }, [quotationDetails.factoryID]);

    useEffect(() => {
        setQuotationDetailsData([]);
        trackPromise(getFactoriesForDropdown());
        setQuotationDetails({
            ...quotationDetails,
            factoryID: '0'
        });
    }, [quotationDetails.groupID]);

    useEffect(() => {
        trackPromise(getPermissions(), getGroupsForDropdown(),
            generateQuotationNumber());
    }, []);

    useEffect(() => {
        trackPromise(getStatus());

    }, []);

    useEffect(() => {
        setQuotationDetailsData([]);
        setIsShowTable(false);
    }, [quotationDetails.statusID]);

    const handleChange = (e) => {
        setQuotationDetails({ ...quotationDetails, [e.target.name]: e.target.value });
    };

    function generateDropDownMenu(data) {
        return Object.entries(data || {}).map(([key, value]) => (
            <MenuItem key={key} value={Number(key)}>
                {value}
            </MenuItem>
        ));
    }
    const generateFactoryDropDownMenu = (data) => {
        return data ? data.map(({ id, name }) => (
            <MenuItem key={id} value={id}>{name}</MenuItem>
        )) : [];
    };

    async function generateQuotationNumber() {
        let date = new Date();
        let year = date.getFullYear().toString();
        let month = date.getMonth() + 1;
        let dt = date.getDate();
        let hours = date.getHours().toString().padStart(2, '0');
        let minutes = date.getMinutes().toString().padStart(2, '0');
        let dl = hours + minutes;
        year = year.slice(2);
        var maxNumber = 100;
        var randomNumber = Math.floor((Math.random() * maxNumber) + 1);
        let invoiceNo = dl + month + year + randomNumber;
        setQuotationNumber(invoiceNo);
    }

    async function getQuotationDetails() {
        let model = {
            groupID: quotationDetails.groupID,
            factoryID: quotationDetails.factoryID,
            statusID: quotationDetails.statusID,
            requisitionID: quotationDetails.requisitionID,
        }

        let item = await services.getQuotationDetails(model.groupID, model.factoryID, model.statusID, model.requisitionID);
        if (item.data.length !== 0 && item.statusCode === 'Success') {
            setQuotationDetailsData(item.data);
            setIsShowTable(true);
        } else {
            setQuotationDetailsData(item.data);
            alert.error("No Records To Display")
        }
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
                <Grid item md={2} xs={12}>
                    <PageHeader
                        onClick={handleClick}
                        isEdit={true}
                        toolTiptitle={"Add Quotation"}
                    />
                </Grid>
            </Grid>
        )
    }

    return (
        <Page className={classes.root} title={title}>
            <LoadingComponent />
            <Container maxWidth={false}>
                <Formik
                    initialValues={
                        {
                            groupID: quotationDetails.groupID,
                            factoryID: quotationDetails.factoryID,
                            statusID: quotationDetails.statusID,
                            requisitionID: quotationDetails.requisitionID,
                        }
                    }
                    validationSchema={Yup.object({
                        groupID: Yup.number().required('Group is required').min(1, 'Group is required'),
                        factoryID: Yup.number().required('Factory is required').min(1, 'Factory is required'),
                    })}
                    onSubmit={getQuotationDetails}
                    enableReinitialize
                >
                    {({ handleSubmit, errors, touched, values }) => (
                        <form onSubmit={handleSubmit}>
                            <Card>
                                <CardHeader title={cardTitle(title)} />
                                <Divider />
                                <CardContent style={{ marginBottom: '2rem' }}>
                                    <Grid container spacing={3}>
                                        <Grid item md={4} xs={12}>
                                            <InputLabel shrink id="groupID">
                                                Group *
                                            </InputLabel>
                                            <TextField
                                                select
                                                name="groupID"
                                                value={quotationDetails.groupID}
                                                onChange={handleChange}
                                                error={touched.groupID && Boolean(errors.groupID)}
                                                helperText={touched.groupID && errors.groupID}
                                                fullWidth
                                                variant="outlined"
                                                size="small"
                                            >
                                                <MenuItem value="0">--Select Group--</MenuItem>
                                                {generateDropDownMenu(groups)}
                                            </TextField>
                                        </Grid>
                                        <Grid item md={4} xs={12}>
                                            <InputLabel shrink id="factoryID">
                                                Factory*
                                            </InputLabel>
                                            <TextField select
                                                error={Boolean(touched.factoryID && errors.factoryID)}
                                                helperText={touched.factoryID && errors.factoryID}
                                                fullWidth
                                                name="factoryID"
                                                onChange={(e) => handleChange(e)}
                                                value={quotationDetails.factoryID}
                                                variant="outlined"
                                                size="small"
                                            >
                                                <MenuItem value="0">--Select Factory--</MenuItem>
                                                {generateFactoryDropDownMenu(factories)}
                                            </TextField>
                                        </Grid>
                                        <Grid item md={4} xs={12}>
                                            <InputLabel shrink id="statusID">
                                                Status
                                            </InputLabel>
                                            <TextField
                                                select
                                                name="statusID"
                                                value={quotationDetails.statusID}
                                                onChange={handleChange}
                                                error={touched.statusID && Boolean(errors.statusID)}
                                                helperText={touched.statusID && errors.statusID}
                                                fullWidth
                                                variant="outlined"
                                                size="small"
                                            >
                                                <MenuItem value="0">--Select Status--</MenuItem>
                                                {generateDropDownMenu(status)}
                                            </TextField>
                                        </Grid>

                                        <Grid item md={4} xs={12}>
                                            <InputLabel shrink id="requisitionID">
                                                Requisition Number
                                            </InputLabel>
                                            <Autocomplete
                                                id="requisitionID"
                                                options={requisitions}
                                                getOptionLabel={(option) => option.requisitionNumber}
                                                onChange={(e, value) => handleSearchDropdownChange(value, e)}
                                                value={requisitions.find(req => req.requisitionID == quotationDetails.requisitionID) || null}
                                                renderInput={(params) =>
                                                    <TextField {...params} placeholder="--Select Requisition No--"
                                                        error={Boolean(touched.requisitionID && errors.requisitionID)}
                                                        helperText={touched.requisitionID && errors.requisitionID}
                                                        variant="outlined"
                                                        name="requisitionID"
                                                        fullWidth
                                                        size='small'
                                                        value={quotationDetails.requisitionID}
                                                        getOptionDisabled={true}
                                                    />
                                                }
                                            />
                                        </Grid>
                                        <Grid container justify="flex-end" spacing={3}>
                                            <Box pr={2} style={{ marginTop: '20px' }}>
                                                <Button
                                                    color="primary"
                                                    type="submit"
                                                    variant="contained"
                                                    size="small"
                                                >
                                                    Search
                                                </Button >
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                                <Box minWidth={1050}>
                                    {QuotationDetailsData.length > 0 && isShowTable ? (
                                        <MaterialTable
                                            title="Multiple Actions Preview"
                                            columns={[
                                                {
                                                    title: 'Factory',
                                                    field: 'factoryName',
                                                    type: 'string',
                                                    cellStyle: { textAlign: 'left', paddingLeft: '20px', verticalAlign: 'middle' },
                                                    headerStyle: { textAlign: 'left', paddingLeft: '20px', verticalAlign: 'middle' }
                                                },
                                                {
                                                    title: 'Quotation Number',
                                                    field: 'quotationNumber',
                                                    type: 'string',
                                                    cellStyle: { textAlign: 'left', paddingLeft: '10px', verticalAlign: 'middle' },
                                                    headerStyle: { textAlign: 'left', paddingLeft: '10px', verticalAlign: 'middle' }
                                                },
                                                {
                                                    title: 'SKU',
                                                    field: 'skuMasterName',
                                                    type: 'string',
                                                    cellStyle: { textAlign: 'left', paddingLeft: '10px', verticalAlign: 'middle' },
                                                    headerStyle: { textAlign: 'left', paddingLeft: '10px', verticalAlign: 'middle' }
                                                },
                                                {
                                                    title: 'Quantity',
                                                    field: 'requestedQuantity',
                                                    type: 'numeric',
                                                    cellStyle: { textAlign: 'center', verticalAlign: 'middle' },
                                                    headerStyle: { textAlign: 'center', paddingRight: '40px', verticalAlign: 'middle' },
                                                    render: rowData =>
                                                        rowData.requestedQuantity != null
                                                            ? Number(rowData.requestedQuantity).toFixed(2)
                                                            : ''
                                                },
                                                {
                                                    title: 'Status',
                                                    field: 'quotationStatusTypeName',
                                                    type: 'string',
                                                    cellStyle: { textAlign: 'center', paddingLeft: '10px', verticalAlign: 'middle' },
                                                    headerStyle: { textAlign: 'center', paddingLeft: '40px', verticalAlign: 'middle' },
                                                    render: rowData => {
                                                        const getStatusConfig = (status) => {
                                                            const configs = {
                                                                'Quotation Called': {
                                                                    bg: '#fff3e0',
                                                                    color: '#e65100',
                                                                    border: '#ffe0b2'
                                                                },
                                                                'Quotation Completed': {
                                                                    bg: '#e3f2fd',
                                                                    color: '#1565c0',
                                                                    border: '#bbdefb'
                                                                },
                                                                'PO Generated': {
                                                                    bg: '#e8f5e9',
                                                                    color: '#2e7d32',
                                                                    border: '#c8e6c9'
                                                                },
                                                            };
                                                            return configs[status] || configs['New'];
                                                        };

                                                        const config = getStatusConfig(rowData.quotationStatusTypeName);

                                                        return (
                                                            <div
                                                                style={{
                                                                    display: 'inline-block',
                                                                    backgroundColor: config.bg,
                                                                    color: config.color,
                                                                    padding: '4px 10px',
                                                                    borderRadius: '50px',
                                                                    fontWeight: '600',
                                                                    fontSize: '14px',
                                                                    border: `2px solid ${config.border}`,
                                                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)',
                                                                    transition: 'all 0.2s ease',
                                                                    cursor: 'default',
                                                                    whiteSpace: 'nowrap'
                                                                }}
                                                            >
                                                                {rowData.quotationStatusTypeName}
                                                            </div>
                                                        );
                                                    }
                                                }
                                            ]}
                                            data={QuotationDetailsData}
                                            options={{
                                                exportButton: false,
                                                showTitle: false,
                                                headerStyle: { height: '1%' },
                                                columnResizable: false,
                                                actionsColumnIndex: -1,
                                                pageSize: 10
                                            }}
                                        />
                                    ) : null}
                                </Box>

                            </Card>
                        </form>
                    )}
                </Formik>
            </Container>
        </Page >
    );
}